import React from 'react';

import { StyledTab } from './tab-styles';

const Tab = (props) => (
  <StyledTab {...props} />
);

export default Tab;
